import { bool, exact, number } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const optionFieldType = exact({
  name: number.isRequired,
  key: number.isRequired,
  isListField: bool.isRequired,
  fieldKey: number.isRequired,
});
